import React from 'react'
import { Grid, Typography, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/styles'
import ShowTeacherAvailableTimeCalendar from './ShowTeacherAvailableTimeCalendar'
import LessonList from './LessonList'
import Spinner from '../../ui/Spinner'

const ChooseLesson = ({
  currentTeacher,
  lessonListState,
  calendarEvents,
  loading,
  loadingLessons,
  nextPage,
}) => {
  const theme = useTheme()
  const matchesMD = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <Grid item container direction="column" alignItems="center" spacing={2} style={{ width: '100%', margin: '0' }}>
      <Grid item>
        <Typography
          variant="h4"
          style={{ textAlign: 'center', fontWeight: '600' }}
        >
          Chọn kiểu bài học
        </Typography>
      </Grid>
      <Grid item>
        {currentTeacher && (
          <Typography variant="h6">{currentTeacher.name}</Typography>
        )}
      </Grid>

      <Grid item style={{ minWidth: '50%' }}>
        {loadingLessons ? (
          <Spinner />
        ) : (
          <LessonList lessons={lessonListState} nextPage={nextPage} />
        )}
      </Grid>

      {matchesMD && (
        <Grid item container direction="column" alignItems="center" spacing={1} sx={{ marginTop: '1em' }}>
          <Grid item>
            <Typography variant="h4" style={{ fontWeight: '500' }}>
              Lịch của giáo viên:
            </Typography>
          </Grid>

          <Grid item>
            <Typography variant='h6'>
              (Lịch phía dưới chỉ để xem, bạn vui lòng chọn kiểu bài học trước khi chọn thời gian để học.)
            </Typography>
          </Grid>
          <Grid item>
            {loading ? (
              <Spinner />
            ) : (
              <ShowTeacherAvailableTimeCalendar
                calendarEvents={calendarEvents}
              />
            )}
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}

export default ChooseLesson
